import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCircleExclamationCheck } from '@fortawesome/pro-light-svg-icons';

export type ProLightCircleExclamationCheckProps = IconComponentProps;

export const ProLightCircleExclamationCheck = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCircleExclamationCheckProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCircleExclamationCheck}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCircleExclamationCheck}
    />
  );
};

ProLightCircleExclamationCheck.displayName = 'ProLightCircleExclamationCheck';
